import { apiInstances } from '../../../../libs';

const { put, post, patch } = apiInstances.userInstance;

export const saveBankAccountInfoService = async ({
  userId,
  userType,
  payload,
  isUpdate,
}) => {
  const endpoint = `/users/${userId}/${userType}/bank-account`;

  if (isUpdate === undefined) {
    return put(endpoint, payload);
  }

  return isUpdate ? patch(endpoint, payload) : post(endpoint, payload);
};
